import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=798cd6cb&scoped=true&v-for=(footer%2C%20index)%20in%20footer&%3Akey=index&"
import script from "./Footer.js?vue&type=script&lang=js&"
export * from "./Footer.js?vue&type=script&lang=js&"
import style0 from "./Footer.scss?vue&type=style&index=0&id=798cd6cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798cd6cb",
  null
  
)

export default component.exports